import { IrisFilterPropertyMeta } from '@iris/modules/module-filters-v2/filter-meta';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { of } from 'rxjs';
import { filterValueUniversalIsEmpty } from '@iris/modules/module-filters-v2/utils';
import { StrakitNumberComponent } from '@ngx-strakit/cdk/controls';
import { ComponentRef, inject, runInInjectionContext } from '@angular/core';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';

export function numberFilterMeta(propertyId: string, label: string, filterName: string): IrisFilterPropertyMeta<number> {
  return {
    propertyId,
    label,
    appendFilterQueryParamsFn: (builder, value) => {
      return builder.filter(filterName, [value]);
    },
    filterRenderingOptions: {
      component: StrakitNumberComponent,
      getFilterValueFn: (componentInstance: StrakitNumberComponent) =>
        componentInstance.outerControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
      initComponentFn: (componentRef: ComponentRef<StrakitNumberComponent>) => {
        const componentInstance = componentRef.instance;
        const injector = componentRef.injector;

        runInInjectionContext(injector, () => {
          const globalSandbox = inject(IrisGlobalSandbox);
          const theme = globalSandbox.theme();

          if(theme?.strabagControlsEnabled) {
            componentInstance.stylingControlDirective.stylingMode.set('automatized');
            componentInstance.stylingControlDirective.noSubscriptBox.set(true);
            componentInstance.stylingControlDirective.extraDense.set(true);
          } else {
            componentInstance.stylingControlDirective.stylingMode.set('unformed');
          }
        });

        componentInstance.showClear = true;

        return of(null);
      },
      setValueFn: (componentInstance: StrakitNumberComponent, value) => componentInstance.outerControl.patchValue(value ?? null , { emitEvent: false }),
    },
    filterValueIsEmpty: filterValueUniversalIsEmpty,
  };
}
